import React, {
    useEffect,
    useState,
  } from "react";
  import {
    collection,
    deleteDoc,
    doc,
    onSnapshot,
    query,
    updateDoc,
    where,
  } from "firebase/firestore";
  import {
    useNavigate,
    useParams,
  } from "react-router-dom";
  import { db } from "../firebase";
  import websocket from "../services/websocket";
  import "./TradeDetails.css";
  import ForexHeader from "./ForexHeader";
import ForexBottomNav from "../Components/ForexBottomNav"

  const TradeDetails = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [trade, setTrade] = useState(null);
    const [stopLoss, setStopLoss] = useState("");
    const [takeProfit, setTakeProfit] = useState("");
    const [price, setPrice] = useState(0);
    const [liveProfit, setLiveProfit] = useState(0);
    const [closeLots, setCloseLots] = useState(0.01);
    const [activeTab, setActiveTab] =
      useState("trade");
      const [oppositeTrades, setOppositeTrades] = useState([]);
      useEffect(() => {
        if (!trade) return;
        const q = query(
            collection(db, "Forex"),
            where("symbol", "==", trade.symbol),
            where(
                "side",
                "==",
                trade.side === "buy"
                    ? "sell"
                    : "buy"
            )
        );
        const unsubscribe = onSnapshot(q, (snapshot) => {
            const list = [];
            snapshot.forEach((doc) => {
                if (doc.id !== trade.id) {
                    list.push({
                        id: doc.id,
                        ...doc.data(),
                    });
                }
            });
            setOppositeTrades(list);
        });
        return unsubscribe;
    }, [trade]);
    useEffect(() => {
      const unsubscribe =
        onSnapshot(
          doc(db, "Forex", id),
          (snapshot) => {
            if (!snapshot.exists()) {
              return;
            }
            setStopLoss(snapshot.data().stopLoss || "");
            setTakeProfit(snapshot.data().takeProfit || "");
            setTrade({
              id: snapshot.id,
              ...snapshot.data(),
            });
          }
        );
      return unsubscribe;
    }, [id]);
    useEffect(() => {
      if (!trade) return;
      websocket.connect();
      const symbol =
        String(trade.symbol)
          .replace(/[^A-Za-z]/g, "")
          .toUpperCase();
      websocket.history(
        `frx${symbol}`,
        30
      );
      const unsubscribe =
        websocket.onTick((data) => {
          if (!data.tick) return;
          const api =
            String(data.tick.symbol);
          if (
            api !== `frx${symbol}`
          ) {
            return;
          }
          setPrice(
            Number(data.tick.quote)
          );
          const currentPrice = Number(data.tick.quote);
          setPrice(currentPrice);
          const openPrice = Number(trade.openPrice);
          const lots = Number(trade.lots);
          let profit = 0;
          if (trade.side === "buy") {
              profit =
                  (currentPrice - openPrice)
                  * lots
                  * 100000;
          } else {
              profit =
                  (openPrice - currentPrice)
                  * lots
                  * 100000;
          }
          setLiveProfit(profit);
        });
      return unsubscribe;
    }, [trade]);
    if (!trade) {
      return (
        <div className="trade-loading">
          Loading...
        </div>
      );
    }
    const side =
      trade.side === "sell"
        ? "Sell"
        : "Buy";
        const pnl = liveProfit;
      const updateTrade = async () => {
        try {
          await updateDoc(doc(db, "Forex", trade.id), {
            stopLoss: stopLoss === "" ? null : Number(stopLoss),
            takeProfit: takeProfit === "" ? null : Number(takeProfit),
          });
          alert("Trade updated successfully.");
        } catch (err) {
          console.log(err);
        }
      };
      const partialClose = async () => {
        try {
          const remainingLots =
            Number(trade.lots) - Number(closeLots);
          if (remainingLots <= 0) {
            await deleteDoc(
              doc(db,"Forex",trade.id)
            );
            navigate(-1);
            return;
          }
          await updateDoc(
            doc(db,"Forex",trade.id),
            {
              lots: remainingLots
            }
          );
          alert("Partial Close Successful");
        } catch(err){
          console.log(err);
        }
      };
    return (
      <div className="trade-details-page">
        <ForexHeader />
  <ForexBottomNav />
        {/* HEADER */}
        <header className="trade-header">
          <button
            className="trade-back"
            onClick={() => navigate(-1)}
          >
            ←
          </button>
          <div className="trade-header-left">
            <span
              className={
                trade.side === "buy"
                  ? "buy-tag"
                  : "sell-tag"
              }
            >
              {side}
            </span>
            <div>
              <h2>
                {trade.symbol}
              </h2>
              <small>
                {price.toFixed(5)}
              </small>
            </div>
          </div>
          <div className="trade-header-right">
            <strong
              className={
                pnl >= 0
                  ? "profit"
                  : "loss"
              }
            >
              ${Number(pnl).toFixed(2)}
            </strong>
            <small>
              {Number(trade.lots).toFixed(2)}
              {" "}lots @{" "}
              {Number(
                trade.openPrice
              ).toFixed(5)}
            </small>
          </div>
        </header>
        {/* TABS */}
        <div className="trade-tabs">
          <button
            className={
              activeTab === "trade"
                ? "active"
                : ""
            }
            onClick={() =>
              setActiveTab("trade")
            }
          >
            Trade
          </button>
          <button
            className={
              activeTab === "partial"
                ? "active"
                : ""
            }
            onClick={() =>
              setActiveTab(
                "partial"
              )
            }
          >
            Partial Close
          </button>
          <button
            className={
              activeTab === "closeby"
                ? "active"
                : ""
            }
            onClick={() =>
              setActiveTab(
                "closeby"
              )
            }
          >
            Close By
          </button>
          <button
            className={
              activeTab === "history"
                ? "active"
                : ""
            }
            onClick={() =>
              setActiveTab(
                "history"
              )
            }
          >
            History
          </button>
          <button
            className={
              activeTab === "info"
                ? "active"
                : ""
            }
            onClick={() =>
              setActiveTab(
                "info"
              )
            }
          >
            Info
          </button>
        </div>
        <div className="trade-body">
        {activeTab === "trade" && (
  <div className="modify-trade">
  <div className="field">
  <label>Open Price</label>
  <input
  readOnly
  value={Number(trade.openPrice).toFixed(5)}
  />
  </div>
  <div className="field">
  <label>Current Price</label>
  <input
  readOnly
  value={price.toFixed(5)}
  />
  </div>
  <div className="field">
  <label>Stop Loss</label>
  <input
  type="number"
  step="0.00001"
  value={stopLoss}
  onChange={(e)=>setStopLoss(e.target.value)}
  />
  </div>
  <div className="field">
  <label>Take Profit</label>
  <input
  type="number"
  step="0.00001"
  value={takeProfit}
  onChange={(e)=>setTakeProfit(e.target.value)}
  />
  </div>
  <div className="field">
  <label>Volume</label>
  <input
  readOnly
  value={`${trade.lots} Lots`}
  />
  </div>
  <button
  className="confirm-btn"
  onClick={updateTrade}
  >
  Confirm
  </button>
  </div>
  )}
  {activeTab === "partial" && (
  <div className="partial-close">
  <h3>Partial Close</h3>
  <div className="field">
  <label>Current Lots</label>
  <input
  readOnly
  value={trade.lots}
  />
  </div>
  <div className="field">
  <label>Lots To Close</label>
  <input
  type="number"
  step="0.01"
  min="0.01"
  max={trade.lots}
  value={closeLots}
  onChange={(e)=>
  setCloseLots(Number(e.target.value))
  }
  />
  </div>
  <div className="field">
  <label>Remaining Lots</label>
  <input
  readOnly
  value={(
  Number(trade.lots)-Number(closeLots)
  ).toFixed(2)}
  />
  </div>
  <button
  className="close-btn"
  onClick={partialClose}
  >
  Close Position
  </button>
  </div>
  )}
  {activeTab === "closeby" && (
  <div className="closeby-page">
  <h3>Available Positions</h3>
  {oppositeTrades.length === 0 ? (
  <p className="empty">
  No opposite position found.
  </p>
  ) : (
  oppositeTrades.map((item)=>(
  <div
  key={item.id}
  className="closeby-card"
  >
  <div>
  <strong>
  {item.side.toUpperCase()}
  </strong>
  <p>{item.symbol}</p>
  </div>
  <div>
  <p>
  {Number(item.lots).toFixed(2)}
  Lots
  </p>
  <p>
  @
  {Number(item.openPrice).toFixed(5)}
  </p>
  </div>
  <button
  className="closeby-btn"
  >
  Close By
  </button>
  </div>
  ))
  )}
  </div>
  )}
         {activeTab === "history" && (
  <div className="history-page">
  <div className="history-card">
  <div className="history-row">
  <span>Ticket</span>
  <strong>{trade.id}</strong>
  </div>
  <div className="history-row">
  <span>Symbol</span>
  <strong>{trade.symbol}</strong>
  </div>
  <div className="history-row">
  <span>Type</span>
  <strong>{trade.side.toUpperCase()}</strong>
  </div>
  <div className="history-row">
  <span>Volume</span>
  <strong>{trade.lots} Lots</strong>
  </div>
  <div className="history-row">
  <span>Open Price</span>
  <strong>
  {Number(trade.openPrice).toFixed(5)}
  </strong>
  </div>
  <div className="history-row">
  <span>Current Price</span>
  <strong>
  {price.toFixed(5)}
  </strong>
  </div>
  <div className="history-row">
  <span>Profit</span>
  <strong
  className={
  Number(trade.profitLoss)>=0
  ?
  "profit"
  :
  "loss"
  }
  >
  ${liveProfit.toFixed(2)}
  </strong>
  </div>
  <div className="history-row">
  <span>Status</span>
  <strong>
  {trade.status || "Open"}
  </strong>
  </div>
  <div className="history-row">
  <span>Opened</span>
  <strong>
  {trade.createdAt
  ?
  new Date(
  trade.createdAt.seconds*1000
  ).toLocaleString()
  :
  "--"}
  </strong>
  </div>
  </div>
  </div>
  )}
  {activeTab === "info" && (
  <div className="info-page">
  <div className="info-card">
  <div className="info-row">
  <span>Ticket</span>
  <strong>{trade.id}</strong>
  </div>
  <div className="info-row">
  <span>Symbol</span>
  <strong>{trade.symbol}</strong>
  </div>
  <div className="info-row">
  <span>Order Type</span>
  <strong>{trade.side.toUpperCase()}</strong>
  </div>
  <div className="info-row">
  <span>Volume</span>
  <strong>{trade.lots} Lots</strong>
  </div>
  <div className="info-row">
  <span>Open Price</span>
  <strong>{Number(trade.openPrice).toFixed(5)}</strong>
  </div>
  <div className="info-row">
  <span>Current Price</span>
  <strong>{price.toFixed(5)}</strong>
  </div>
  <div className="info-row">
  <span>Stop Loss</span>
  <strong>
  {trade.stopLoss
  ? Number(trade.stopLoss).toFixed(5)
  : "--"}
  </strong>
  </div>
  <div className="info-row">
  <span>Take Profit</span>
  <strong>
  {trade.takeProfit
  ? Number(trade.takeProfit).toFixed(5)
  : "--"}
  </strong>
  </div>
  <div className="info-row">
  <span>Margin</span>
  <strong>
  ${Number(trade.margin || 0).toFixed(2)}
  </strong>
  </div>
  <div className="info-row">
  <span>Leverage</span>
  <strong>
  1:{trade.leverage || 100}
  </strong>
  </div>
  <div className="info-row">
  <span>Swap</span>
  <strong>
  ${Number(trade.swap || 0).toFixed(2)}
  </strong>
  </div>
  <div className="info-row">
  <span>Commission</span>
  <strong>
  ${Number(trade.commission || 0).toFixed(2)}
  </strong>
  </div>
  <div className="info-row">
  <span>Profit</span>
  <strong
  className={
  Number(trade.profitLoss || 0) >= 0
  ? "profit"
  : "loss"
  }
  >
  ${Number(trade.profitLoss || 0).toFixed(2)}
  </strong>
  </div>
  <div className="info-row">
  <span>Comment</span>
  <strong>
  {trade.comment || "--"}
  </strong>
  </div>
  </div>
  </div>
  )}
        </div>
      </div>
    );
  };
  export default TradeDetails;